export class GetDataCatalogDatasetResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "DataCatalogDataset",
            "format": ""
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "DataCatalogDatasetSchema",
            "format": ""
        },
        {
            "name": "joinability",
            "baseName": "joinability",
            "type": "Array<DataCatalogJoinabilityEntry>",
            "format": ""
        },
        {
            "name": "queryLogsUrl",
            "baseName": "queryLogsUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "hashSamplingUrl",
            "baseName": "hashSamplingUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogDatasetResponse.attributeTypeMap;
    }
    constructor() {
    }
}
